module.exports = __webpack_public_path__ + "img/equipment-coat-01.500c3d30.png";